<template>
  <button
    class="text-white py-2 px-4 rounded cursor-pointer bg-cardstock-green-500 text-center whitespace-nowrap"
    :class="{'bg-gray-500 cursor-wait': isSubmitting, 'bg-gray-500 cursor-not-allowed': isDisabled}"
    tabindex="0"
    :disabled="shouldDisableButton"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    isSubmitting: {
      type: Boolean,
      required: false,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    shouldDisableButton() {
      return this.isSubmitting || this.isDisabled
    }
  }
}
</script>
